module.exports = __webpack_public_path__ + "static/media/devices.83453ebf.svg";